<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="specific-commerce">
      <Title jpn="Ley de transacciones comerciales específicas" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Nombre de la empresa operadora</span>
            <span class="text">Hatchi Co., Ltd.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">persona representativa</span>
            <span class="text">Ken Yatsuka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Dirección de registro de la empresa/dirección de la oficina comercial</span>
            <span class="text">547-0011</span>
            <span class="text">3-39 Nagayoshi Deto 7-chome, Hirano-ku, ciudad de Osaka, prefectura de Osaka</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">número telefónico</span>
            <span class="text">06-6643-9996</span>
            <span class="text">(*Horario de recepción: Laborables de 10:00 a 17:00)</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">dirección de correo electrónico</span>
            <span class="text">soporte@xeroplace.jp</span>
            <span class="text">*Para consultas, utilice el chat del sitio. En principio, le responderemos en un plazo de 2 días hábiles.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">precio</span>
            <span class="text">Display para cada producto</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
        class="shadow-box-title-description"
        title=""
        >
        <div class="text-container left">
            <span class="text">Cargos necesarios distintos del precio del producto</span>
            <span class="text">Costos relacionados con equipos para el uso de los servicios prestados por nuestra empresa, tarifas de conexión a Internet, tarifas de comunicación por paquetes, impuesto al consumo y tarifas de transferencia para el pago.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">El tiempo de entrega</span>
            <span class="text">Al aceptar solicitudes</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Cantidad de ventas</span>
            <span class="text">No hay especificaciones específicas.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Método de pago</span>
            <span class="text">Aceptamos tarjeta de crédito, PayPal y Amazon Pay.</span>
            <span class="text">*No podemos aceptar cancelaciones debido a la conveniencia del cliente después del pago. Gracias por su comprensión.</span>
            <span class="text">Si el pago no se realiza dentro del plazo, quedará automáticamente cancelado.</span>
            <span class="text">Periodo de pago</span>
            <span class="text">Tarjeta de crédito: Según los términos y condiciones de la compañía de la tarjeta de crédito.</span>
            <span class="text">PayPal: basado en los términos de PayPal.</span>
            <span class="text">Amazonpay: Basado en los términos y condiciones de Amazonpay.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Política de devolución y plazo</span>
            <span class="text">Como regla general, no aceptamos devoluciones ni cambios, pero si somos 100% culpables, responderemos.</span>
            <span class="text">Sin embargo, no podemos responder en los siguientes casos. Gracias por su comprensión.</span>
            <span class="text">Si el artículo se pierde o daña durante el proceso de entrega</span>
            <span class="text">Si no hay una grabación de vídeo de artículos sin abrir, como BOX, etc.</span>
            <span class="text">*Tenemos especial cuidado al inspeccionar productos reencogidos.</span>
            <span class="text">Si han pasado más de 10 días desde que llegó el producto</span>
            <span class="text">Si encuentra rayones, etc. en un artículo de tasación como PSA, aceptamos su solicitud de cambio o devolución en base a ese motivo.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container left">
            <span class="text">Licencia comercial de anticuario</span>
            <span class="text">No 431370066203</span>
            <span class="text">Lugar cero Co., Ltd.</span>
            <span class="text">Comisión de Seguridad Pública de la Prefectura de Saitama</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';

export default {
  name: 'SpecificCommerce',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),

  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.specific-commerce{
  width: 100%;
  max-width: 1000px;
  padding: 30px 20px 0;
  margin: 0 auto;
  .specific-commerce-title{
    display: flex;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: blue!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
          &.none{
            color: red;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
table.code {
  width: 100%;
  th, td {
    font-size: 16px;
    color: $white;
  }
  th {
    font-weight: normal;
    text-align: left;
    padding-right: 10px;
    width: 200px;
  }
  td {
    text-align: left;
    padding-left: 10px;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .specific-commerce{
    .scroll-container{
      .shadow-box-title-description{
        .text-container{
          .text{
            font-size: 14px;
          }
        }
      }
    }
  }
  table.code {
    width: 100%;
    th, td {
      display: block;
      font-size: 14px;
    }
    th {
      text-align: left;
      padding-right: 0;
      &:after {
        content: '';
      }
    }
    td {
      text-align: left;
      padding-left: 0;
      padding-bottom: 10px;
    }
  }
  .left {
    text-align: left!important;
  }
}
</style>
